import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import {getArtworkDetailUrl, sanity_s3_url_display} from '../component/Utils'
import QRCode from 'qrcode'
import {IN_PRODUCT} from "../config/product";

pdfMake.vfs = pdfFonts

export const getFileNameByUrl = (url) => {
    return url.substring(url.lastIndexOf('/') + 1, url.length)
}

const typeTemplate = '${label} is not a valid ${type}'

export const validateMessages = {
    default: 'Validation error on field ${label}',
    required: "${label} can't be blank",
    enum: '${label} must be one of [${enum}]',
    whitespace: '${label} cannot be empty',
    date: {
        format: '${label} is invalid for format date',
        parse: '${label} could not be parsed as date',
        invalid: '${label} is invalid date'
    },
    types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
    },
    string: {
        len: '${label} must be exactly ${len} characters',
        min: '${label} must be at least ${min} characters',
        max: '${label} cannot be longer than ${max} characters',
        range: '${label} must be between ${min} and ${max} characters'
    },
    number: {
        len: '${label} must equal ${len}',
        min: '${label} cannot be less than ${min}',
        max: '${label} cannot be greater than ${max}',
        range: '${label} must be between ${min} and ${max}'
    },
    array: {
        len: '${label} must be exactly ${len} in length',
        min: '${label} cannot be less than ${min} in length',
        max: '${label} cannot be greater than ${max} in length',
        range: '${label} must be between ${min} and ${max} in length'
    },
    pattern: {
        mismatch: '${label} does not match pattern ${pattern}'
    }
}

export const getFullNameByArtist = (artist) => {
    const full_name = artist.first_name + (artist.middle_name == null ? '' : ' ' + artist.middle_name) + ' ' + artist.last_name;
    if (full_name.length < 30) {
        return full_name
    }else{
        return full_name.substring(0, 30) + ".."
    }
}

export const checkFirstTimeUser = (props) => {
    if (window !== undefined) {
        const KEY_DASHBOARD = 'REVART_TOUR_DASHBOARD_PIECES_'+ (props?.id || '') + '_' + (props?.role || '')
        const KEY_PIECES = 'REVART_TOUR_NEW_PIECES_'+ (props?.id || '') + '_' + (props?.role || '')
        const OLD_KEY = 'REVART_TOUR_PIECES_'+ (props?.id || '') + '_' + (props?.role || '')
        try {
            const is_seen = Boolean(localStorage.getItem(OLD_KEY))
            if (is_seen) {
                localStorage.setItem(KEY_DASHBOARD, 'true')
                localStorage.setItem(KEY_PIECES, 'true')
            }
        }catch (e) {
        }
    }
}

export const checkFirstTimeDashboardUser = (props) => {
    if (window !== undefined) {
        checkFirstTimeUser(props)
        const KEY_DASHBOARD = 'REVART_TOUR_DASHBOARD_PIECES_'+ (props?.id || '') + '_' + (props?.role || '')
        try {
            const is_seen = Boolean(localStorage.getItem(KEY_DASHBOARD))
            if (is_seen) {
                return false
            }
            localStorage.setItem(KEY_DASHBOARD, 'true')
            return true
        }catch (e) {
            localStorage.setItem(KEY_DASHBOARD, 'true')
            return true
        }
    }
    return false
}

export const checkFirstTimePiecesUser = (props) => {
    if (window !== undefined) {
        checkFirstTimeUser(props)
        const KEY_PIECES = 'REVART_TOUR_NEW_PIECES_'+ (props?.id || '') + '_' + (props?.role || '')
        try {
            const is_seen = Boolean(localStorage.getItem(KEY_PIECES))
            if (is_seen) {
                return false
            }
            localStorage.setItem(KEY_PIECES, 'true')
            return true
        }catch (e) {
            localStorage.setItem(KEY_PIECES, 'true')
            return true
        }
    }
    return false
}

export const exportInventoryReportPdf = async (
    artistNamesInput,
    artistCollections,
    date,
    artworksInput,
    collection_filter = null,
    business_type_filter = null
) => {

    function sanitySize(size) {
        try {
            if (size.indexOf('.') > -1) {
                return parseFloat(size)
            }
            return parseInt(size)
        } catch (e) {
            return size
        }
    }

    // let artwork
    function capitalizeFirstLetter(string) {
        if (!string) return ''
        const strings = string.split(' ')
        let ret = []
        for (let i = 0; i < strings.length; i++) {
            const str = strings[i]
            ret.push(str.charAt(0).toUpperCase() + str.slice(1))
        }
        return ret.join(' ')
    }

    let artistNamesList = []
    let artworksList = []
    let artistLinkList = []

    if (Array.isArray(artistNamesInput)) {
        artistNamesList = artistNamesInput.map((data)=>{
            return getFullNameByArtist(data)
        })
        artistNamesInput.forEach((artistName)=>{
            artistLinkList.push(`https://revart.co/artist/${artistName.first_name}_${artistName.last_name}_${artistName.artist}`)
            let artistArtworksList = artworksInput.filter((artwork)=>{
                return artwork.artist?.toString() === artistName.artist?.toString()
            })
            artworksList.push(artistArtworksList)
        })
    }else {
        artistNamesList.push(getFullNameByArtist(artistNamesInput))
        artworksList.push(artworksInput)
        artistLinkList.push(`https://revart.co/artist/${artistNamesInput.first_name}_${artistNamesInput.last_name}_${artistNamesInput.artist}`)
    }

    const collections = artistCollections
    const email = 'sales@revart.co'
    const dateTedt = `Available on ${date}`
    let images = null
    if (Array.isArray(artistNamesInput)) {
        images = artworksInput.reduce((acc, artwork) => {
            acc['imageId:' + artwork.id] = sanity_s3_url_display(artwork.static_url) + '?no-cache'
            return acc
        }, {})
    }else {
        images = artistLinkList.reduce((acc, artwork) => {
            acc['imageId:' + artwork.id] = sanity_s3_url_display(artwork.static_url) + '?no-cache'
            return acc
        }, {})
    }

    // let collectionName = null
    if (collection_filter) {
        collections.filter((c) => {
            return c.id === collection_filter
        })
        if (collections.length > 0) {
            // collectionName = collections[0].title
        }
    }

    function get_artist_artwork_content(artistName,  link, the_columns) {
        return [
            {text: capitalizeFirstLetter(artistName), fontSize: 16},
            {text: email, fontSize: 10},
            {text: link, fontSize: 10},
            {text: dateTedt, fontSize: 10},
            business_type_filter ? {
                text: business_type_filter.map((c) => capitalizeFirstLetter(c)).join('/'),
                fontSize: 10
            } : null,
            {
                canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1}],
                margin: [0, 20, 0, 0]
            },
            ...the_columns
        ]
    }

    let all_content = []
    let count = 0
    for (let i = 0; i < artistNamesList.length; i++) {
        let _name = artistNamesList[i]
        let _link = artistLinkList[i]
        let _artworks = artworksList[i]
        const columns = _artworks.map((artwork, index, artworks) => {
            let w = artwork.frame_size_w
            let h = artwork.frame_size_h
            let d = artwork.frame_size_d
            let sizes = Array(3)
            sizes[0] = h ? h.toString() : '0'
            sizes[1] = w ? w.toString() : '0'
            sizes[2] = d ? d.toString() : '0'

            let sizeTextStr
            if (sizes[0] === '0' || sizes[1] === '0' || sizes[0] === '-1' || sizes[1] === '-1') {
                sizeTextStr = 'Size: not available'
            } else if (sizes[2] !== '0' && sizes[2] !== '0.0' && sizes[2] !== '-1') {
                sizeTextStr = `Size: ${sanitySize(sizes[0])}" x ${sanitySize(sizes[1])}" x ${sanitySize(sizes[2])}"`
            } else {
                sizeTextStr = `Size: ${sanitySize(sizes[0])}" x ${sanitySize(sizes[1])}"`
            }
            const sizeText = sizeTextStr

            let materialMediumText = ''
            if (
                artwork.material_type_str &&
                artwork.medium_type_str &&
                artwork.material_type_str !== 'null' &&
                artwork.medium_type_str !== 'null'
            ) {
                materialMediumText = artwork.material_type_str
            } else {
                if (artwork.material_type_str && artwork.material_type_str !== 'null') materialMediumText = artwork.material_type_str
                if (artwork.medium_type_str && artwork.medium_type_str !== 'null') materialMediumText = artwork.medium_type_str
            }

            let yearText
            if (artwork.year && artwork.year !== -1) yearText = 'Year: ' + artwork.year
            else yearText = 'Year:  Not available'

            let checkIfCollection = (artwork) => {
                let res = collections.filter((item) => {
                    return item.artworks.includes(artwork.id)
                })
                if (res.length > 0) {
                    return 'Artwork Series Name: ' + res.map((v) => v.title).join(', ')
                } else {
                    return ''
                }
            }

            count += 1

            return {
                columns: [
                    {image: 'imageId:' + artwork.id, fit: [150, 150], width: 150, alignment: 'center'},
                    {
                        stack: [
                            {
                                text: artwork?.name?.replace('.jpg', '').replace('.jpeg', '').replace('.png', ''),
                                bold: true,
                                italics: true,
                                fontSize: 16
                            },
                            // "Artwork Series Name (Not Implemented)"
                            {text: checkIfCollection(artwork), fontSize: 12, margin: [0, 5, 0, 0]},
                            {text: yearText, fontSize: 12, margin: [0, 5, 0, 0]},
                            materialMediumText !== '' ? {text: materialMediumText, fontSize: 12, margin: [0, 5, 0, 0]} : {},
                            {text: sizeText, fontSize: 12, margin: [0, 5, 0, 0]},
                            // {text: businessTypeText, fontSize: 12, margin: [0, 5, 0, 0]},
                            artwork.price_type_str
                                ? {
                                    text: 'Price: $ ' + Number(artwork.price_type_str).toLocaleString(),
                                    bold: true,
                                    fontSize: 12,
                                    margin: [0, 5, 0, 0]
                                }
                                : null
                        ],
                        pageBreak: ((index + 1) % 4 === 0 || index === artworks.length - 1 && count !== artworksInput.length) ? 'after' : null
                    }
                ],
                columnGap: 20,
                margin: [0, 20, 0, 0]
            }
    })
        all_content = all_content.concat(get_artist_artwork_content(_name, _link, columns))
    }

    const docDefinition = {
        pageSize: 'A4',
        info: {
            title: 'Inventory Report',
            author: 'RevArt'
        },
        content: all_content,
        images,
        footer: function (currentPage, pageCount) {
            return {
                text: currentPage.toString(),
                alignment: 'center',
                style: 'normalText',
                layout: 'noBorders'
            }
        }
    }

    return new Promise((resolve, reject) => {
        try {
            pdfMake.createPdf(docDefinition).open()
            resolve('success')
        } catch (error) {
            reject(error)
        }
    })
}

export const exportExhibitionReportPdf = async (
    email,
    artistNames,
    date,
    artworksList,
    exhibition
) => {
    const showArtistName = artistNames.length > 1
    const exhibitionName = exhibition.name
    const dateTedt = `Prepared by today (${date})`
    // const email = 'sales@revart.co'
    const links = []
    artistNames.forEach((artistName)=>{
        links.push({
            text: `https://revart.co/artist/${artistName.first_name}_${artistName.last_name}_${artistName.artist}`,
            fontSize: 12, lineHeight: 1.2
        })
    })

    const type = exhibition.type
    const locationStr = 'Location: '
    const exhibition_desc = exhibition.exhibition_description

    const styleText = {
        bold: false, fontSize: 12, lineHeight: 1.2
    }

    const styleTextBold = {
        bold: true, fontSize: 14, lineHeight: 1.2
    }

    const styleTextSmall = {
        bold: false, fontSize: 10, lineHeight: 1.2
    }

    function getLocation() {
        let line1 = []
        let line2 = []
        if(exhibition.location) line1.push(exhibition.location)
        if(exhibition.street) line1.push(exhibition.street)
        if(exhibition.city) line1.push(exhibition.city)

        if(exhibition.state) line2.push(exhibition.state.toUpperCase())
        if(exhibition.country) line2.push(exhibition.country)
        if(exhibition.zipcode) line2.push(exhibition.zipcode)

        let ret = []
        if (line1.length > 0) {
            ret.push({text: line1.join(', '), ...styleText})
        }
        if (line2.length > 0) {
            ret.push({text: line2.join(', '), ...styleText})
        }

        return ret.length === 0? null: ret
    }

    function getDateMMDDYY(date) {
        try {
            const inputDate = new Date(date);
            return inputDate.toLocaleDateString("en-US", {
                month: "numeric",
                day: "numeric",
                year: "numeric"
            })
        } catch (e) {
            return ''
        }
    }

    function getDates() {
        let dates = []
        if (exhibition.start_date || exhibition.end_date) {
            dates.push({text: '    -  Exhibition Period: From ' + getDateMMDDYY(exhibition.start_date) + " to " + getDateMMDDYY(exhibition.end_date), ...styleText})
        }
        if (exhibition.open_reception_date) {
            dates.push({text: '    -  Opening Reception: ' + getDateMMDDYY(exhibition.open_reception_date), ...styleText})
        }

        if (exhibition.delivery_date) {
            dates.push({text: '    -  Delivery Date: ' + getDateMMDDYY(exhibition.delivery_date), ...styleText})
        }
        if (exhibition.installation_begin_date || exhibition.installation_end_date) {
            dates.push({text: '    -  Installation Period: From ' + getDateMMDDYY(exhibition.start_date) + " to " + getDateMMDDYY(exhibition.end_date), ...styleText})
        }
        if (exhibition.de_installation_begin_date || exhibition.de_installation_end_date) {
            dates.push({text: '    -  Deinstallation Period: From ' + getDateMMDDYY(exhibition.start_date) + " to " + getDateMMDDYY(exhibition.end_date), ...styleText})
        }
        if (exhibition.pick_up_art_date) {
            dates.push({text: '    -  Pick Up Art Date: ' + getDateMMDDYY(exhibition.pick_up_art_date), ...styleText})
        }
        return dates
    }

    const fullNames = []
    artistNames.forEach((artistName)=>{
        fullNames.push(capitalizeFirstLetter(getFullNameByArtist(artistName)))
    })

    const artistName = fullNames.join(',')
    const curatorName = exhibition.curator ?? ''

    let images = {}

    artworksList.forEach((artworks)=>{
        const imagesPart = artworks.reduce((acc, artwork) => {
            acc['imageId:' + artwork.id] = sanity_s3_url_display(artwork.static_url) + '?no-cache'
            return acc
        }, {})
       images = {
            ...images,
           ...imagesPart
       }
    })

    function sanitySize(size) {
        try {
            if (size.indexOf('.') > -1) {
                return parseFloat(size)
            }
            return parseInt(size)
        } catch (e) {
            return size
        }
    }

    let columnList = []

    artworksList.forEach((artworks, index)=> {
        const artistName = fullNames[index]
        const columns = artworks.map((artwork, index, artworks) => {
            let w = artwork.frame_size_w
            let h = artwork.frame_size_h
            let d = artwork.frame_size_d
            let sizes = Array(3)
            sizes[0] = h ? h.toString() : '0'
            sizes[1] = w ? w.toString() : '0'
            sizes[2] = d ? d.toString() : '0'

            let sizeTextStr
            if (sizes[0] === '0' || sizes[1] === '0' || sizes[0] === '-1' || sizes[1] === '-1') {
                sizeTextStr = 'Size: not available'
            } else if (sizes[2] !== '0' && sizes[2] !== '0.0' && sizes[2] !== '-1') {
                sizeTextStr = `Size: ${sanitySize(sizes[0])}" x ${sanitySize(sizes[1])}" x ${sanitySize(sizes[2])}"`
            } else {
                sizeTextStr = `Size: ${sanitySize(sizes[0])}" x ${sanitySize(sizes[1])}"`
            }
            const sizeText = sizeTextStr

            let materialMediumText = ''
            if (
                artwork.material_type_str &&
                artwork.medium_type_str &&
                artwork.material_type_str !== 'null' &&
                artwork.medium_type_str !== 'null'
            ) {
                materialMediumText = artwork.material_type_str
            } else {
                if (artwork.material_type_str && artwork.material_type_str !== 'null') materialMediumText = artwork.material_type_str
                if (artwork.medium_type_str && artwork.medium_type_str !== 'null') materialMediumText = artwork.medium_type_str
            }

            // let businessTypeText
            // if (artwork.used_type) businessTypeText = 'Business Type: ' + artwork.used_type
            // else businessTypeText = 'Business Type: Not available'

            let yearText
            if (artwork.year && artwork.year !== -1) yearText = 'Year: ' + artwork.year
            else yearText = 'Year:  Not available'

            return {
                columns: [
                    {image: 'imageId:' + artwork.id, fit: [150, 150], width: 150, alignment: 'center'},
                    {
                        stack: [
                            {
                                text: artwork.name.replace('.jpg', '').replace('.jpeg', '').replace('.png', ''),
                                bold: true,
                                italics: true,
                                fontSize: 16
                            },
                            showArtistName? {text: "Artist: "+artistName, fontSize: 12, margin: [0, 5, 0, 0]} : null,
                            {text: yearText, fontSize: 12, margin: [0, 5, 0, 0]},
                            materialMediumText !== '' ? {text: materialMediumText, fontSize: 12, margin: [0, 5, 0, 0]} : {},
                            {text: sizeText, fontSize: 12, margin: [0, 5, 0, 0]},
                            // {text: businessTypeText, fontSize: 12, margin: [0, 5, 0, 0]},
                            artwork.price_type_str
                                ? {
                                    text: 'Price: $ ' + Number(artwork.price_type_str).toLocaleString(),
                                    bold: true,
                                    fontSize: 12,
                                    margin: [0, 5, 0, 0]
                                }
                                : null
                        ],
                        pageBreak: (index + 1) % 4 === 0 && index !== artworks.length - 1 ? 'after' : null
                    }
                ],
                columnGap: 20,
                margin: [0, 20, 0, 0]
            }
        })
        columnList = columnList.concat(columns)
    })

    // let artwork
    function capitalizeFirstLetter(string) {
        if (!string) return ''
        const strings = string.split(' ')
        let ret = []
        for (let i = 0; i < strings.length; i++) {
            const str = strings[i]
            ret.push(str.charAt(0).toUpperCase() + str.slice(1))
        }
        return ret.join(' ')
    }

    function capitalizeFirstLetter2(string) {
        if (!string) return ''
        const strings = string.split('-')
        let ret = []
        for (let i = 0; i < strings.length; i++) {
            const str = strings[i]
            ret.push(str.charAt(0).toUpperCase() + str.slice(1))
        }
        return ret.join(' ')
    }

    let spaceBreak = {
        canvas: [],
        margin: [0, 5, 0, 5]
    }

    const docDefinition = {
        pageSize: 'A4',
        info: {
            title: 'Exhibition Inventory Report',
            author: artistName
        },
        content: [
            {text: capitalizeFirstLetter(exhibitionName), fontSize: 24, lineHeight: 1.2},
            {text: dateTedt, fontSize: 10, lineHeight: 1.2},
            {text: email, fontSize: 12, lineHeight: 1.2},
            [...links],
            {...spaceBreak},
            {
                text: [{
                    text: 'Type: ', ...styleTextBold
                },
                    {
                        text: capitalizeFirstLetter2(type), ...styleText
                    },
                ]
            },
            {...spaceBreak},
            [{
                text: [{
                    text: 'Location: ', ...styleTextBold
                },
                ]
            }, getLocation()],
            {...spaceBreak},
            {
                text: [{
                    text: 'Artists: ', ...styleTextBold
                },
                    {
                        text: artistName, ...styleText
                    },
                ]
            },
            {...spaceBreak},
            {
                text: [{
                    text: 'Curator: ', ...styleTextBold
                },
                    {
                        text: capitalizeFirstLetter(curatorName), ...styleText
                    },
                ]
            },
            {...spaceBreak},
            [{
                text: [{
                    text: 'Dates: ', ...styleTextBold
                },
                ]
            }, getDates()],
            {...spaceBreak},
            exhibition_desc ? [{
                text: [{
                    text: 'Exhibition Description: ', ...styleTextBold
                },
                ]
            }, {...spaceBreak}, {
                text: exhibition_desc, ...styleTextSmall
            },] : null,
            {text: '', pageBreak: 'after'},
            {
                canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1}],
                margin: [0, 20, 0, 0]
            },
            ...columnList
        ],
        images,
        footer: function (currentPage, pageCount) {
            return {
                text: currentPage.toString(),
                alignment: 'center',
                style: 'normalText',
                layout: 'noBorders'
            }
        }
    }

    return new Promise((resolve, reject) => {
        try {
            pdfMake.createPdf(docDefinition).open()
            resolve('success')
        } catch (error) {
            reject(error)
        }
    })
}

export const exportInventoryReportQRCode = async (
    artistNamesInput,
    artistCollections,
    date,
    artworksInput,
    collection_filter = null,
    business_type_filter = null
) => {
    let artistNamesList = []
    let artworksList = []

    if (Array.isArray(artistNamesInput)) {
        artistNamesList = artistNamesInput.map((data)=>{
            return getFullNameByArtist(data)
        })
        artworksList = artworksInput
    }else {
        artistNamesList.push(getFullNameByArtist(artistNamesInput))
        artworksList.push(artworksInput)
    }
    console.log(artistNamesList)
    console.log(artworksList)

    const collections = artistCollections
    const qrPromise = []
    artworksList.forEach((artworks)=>{
        if (Array.isArray(artworks)) {
             artworks.forEach((artwork)=>{
                let url = getArtworkDetailUrl(artwork.id, artwork.name)
                qrPromise.push(QRCode.toDataURL(url))
            })
        }else{
            let url = getArtworkDetailUrl(artworks.id, artworks.name)
            qrPromise.push(QRCode.toDataURL(url))
        }
    })
    let images = {}
    const qrResults = await Promise.all(qrPromise)
    let index = 0
    artworksList.forEach((artworks)=>{
        if (Array.isArray(artworks)) {
            artworks.forEach((artwork) => {
                images['imageId:' + artwork.id] = qrResults[index]
                index += 1
            })
        }else{
            images['imageId:' + artworks.id] = qrResults[index]
            index += 1
        }
    })

    function sanitySize(size) {
        try {
            if (size.indexOf('.') > -1) {
                return parseFloat(size)
            }
            return parseInt(size)
        } catch (e) {
            return size
        }
    }

    let columns = []
    let count = 0
    artworksList.forEach((artworks, i, artworksList) => {
        const artistName = artistNamesList[i]
        let update = artworks.map((artwork, index, artworks) => {
            count += 1
            console.log(count, Object.keys(images).length)
            let w = artwork.frame_size_w
            let h = artwork.frame_size_h
            let d = artwork.frame_size_d
            let sizes = Array(3)
            sizes[0] = h ? h.toString() : '0'
            sizes[1] = w ? w.toString() : '0'
            sizes[2] = d ? d.toString() : '0'

            let sizeTextStr
            if (sizes[0] === '0' || sizes[1] === '0' || sizes[0] === '-1' || sizes[1] === '-1') {
                sizeTextStr = ''
            } else if (sizes[2] !== '0' && sizes[2] !== '0.0' && sizes[2] !== '-1') {
                sizeTextStr = `${sanitySize(sizes[0])}" x ${sanitySize(sizes[1])}"`
            } else {
                sizeTextStr = `${sanitySize(sizes[0])}" x ${sanitySize(sizes[1])}"`
            }
            const sizeText = sizeTextStr

            let materialMediumText = ''
            if (
                artwork.material_type_str &&
                artwork.medium_type_str &&
                artwork.material_type_str !== 'null' &&
                artwork.medium_type_str !== 'null'
            ) {
                materialMediumText = artwork.material_type_str
            }

            let yearText
            if (artwork.year && artwork.year !== -1) yearText = '' + artwork.year
            else yearText = ''

            return {
                columns: [
                    {
                        stack: [
                            {
                                image: 'imageId:' + artwork.id,
                                fit: [72, 72],
                                width: 72,
                                right: 0,
                                bottom: 0,
                                absolutePosition: {
                                    x: 200,
                                    y: 90
                                },
                            },
                            {
                                text: capitalizeFirstLetter(artistName),
                                bold: true,
                                fontSize: 18,
                                fontWeight: 400,
                                font: 'Aton',
                                absolutePosition: {
                                    x: 16,
                                    y: 16
                                }
                            },
                            {
                                text: [capitalizeFirstLetter(artwork.name.replace('.jpg', '').replace('.jpeg', '').replace('.png', '')), yearText].join(', '),
                                fontSize: 16,
                                italics: true,
                                fontWeight: 300,
                                font: 'Rubik',
                                absolutePosition: {
                                    x: 16,
                                    y: 48
                                }
                            },
                            materialMediumText !== '' ? {
                                font: 'Rubik',
                                text: materialMediumText,
                                fontSize: 10,
                                margin: [0, 0, 0, 0],
                                absolutePosition: {
                                    x: 16,
                                    y: 76
                                }
                            } : {},
                            sizeText !== '' ? {
                                font: 'Rubik', text: sizeText, fontSize: 10, margin: [0, 5, 0, 0], absolutePosition: {
                                    x: 16,
                                    y: 104
                                }
                            } : {},
                            artwork.price_type_str
                                ? {
                                    text: '$ ' + Number(artwork.price_type_str).toLocaleString(),
                                    bold: true,
                                    fontSize: 11,
                                    absolutePosition: {
                                        x: 16,
                                        y: 132
                                    },
                                }
                                : null,
                            {
                                text: 'Scan for Description and Purchase',
                                italics: true,
                                fontSize: 8,
                                absolutePosition: {
                                    x: 16,
                                    y: 152
                                }
                            },
                            {text: ""}
                        ],
                        pageBreak: count <  Object.keys(images).length ? 'after': null
                    }
                ],
            }
        })
        columns = columns.concat(update)
    })

    // let artwork
    function capitalizeFirstLetter(string) {
        if (!string) return ''
        const strings = string.split(' ')
        let ret = []
        for (let i = 0; i < strings.length; i++) {
            const str = strings[i]
            ret.push(str.charAt(0).toUpperCase() + str.slice(1))
        }
        return ret.join(' ')
    }

    // let collectionName = null
    if (collection_filter) {
        collections.filter((c) => {
            return c.id === collection_filter
        })
        if (collections.length > 0) {
            // collectionName = collections[0].title
        }
    }

    const docDefinition = {
        pageSize: {
           height: 2.5*72 ,
           width: 4*72
        },
        info: {
            title: 'QR Code Report',
            author: 'Powered by RevArt'
        },
        content: [
            ...columns
        ],
        pageMargins: [ 0, 0, 0, 0 ],
        images,
    }


    return new Promise((resolve, reject) => {
        try {
            const fonts = {
               // download default Roboto font from cdnjs.com
                Aton: {
                    normal: 'https://themes.googleusercontent.com/static/fonts/anton/v3/5t8vP9Hx2udzw372glmOxA.ttf',
                     bold: 'https://themes.googleusercontent.com/static/fonts/anton/v3/5t8vP9Hx2udzw372glmOxA.ttf',
                     italics: 'https://themes.googleusercontent.com/static/fonts/anton/v3/5t8vP9Hx2udzw372glmOxA.ttf',
                     bolditalics: 'https://themes.googleusercontent.com/static/fonts/anton/v3/5t8vP9Hx2udzw372glmOxA.ttf'
                },
                 Roboto: {
                     normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                     bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                     italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                     bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
                   },
               Rubik: {
                 normal: 'https://themes.googleusercontent.com/static/fonts/abel/v3/N59kklKPso9WzbZH9jwJSg.ttf',
                 bold: 'https://themes.googleusercontent.com/static/fonts/abel/v3/N59kklKPso9WzbZH9jwJSg.ttf',
                 italics: 'https://themes.googleusercontent.com/static/fonts/abel/v3/N59kklKPso9WzbZH9jwJSg.ttf',
                 bolditalics: 'https://themes.googleusercontent.com/static/fonts/abel/v3/N59kklKPso9WzbZH9jwJSg.ttf'
               },
            }
            pdfMake.createPdf(docDefinition, null, fonts).open()
            resolve('success')
        } catch (error) {
            reject(error)
        }
    })
}

export const exportExhibitionQRCode = async (
    artistNames,
    date,
    artworksList,
    exhibition
) => {
    return exportInventoryReportQRCode(artistNames, [], date, artworksList, null, null)
}